// Source
import * as HelperSrc from "../HelperSrc";
import * as ModelCustomRoute from "../model/custom/Route";
import * as HelperRoute from "./custom/HelperRoute";

export default class StoreRoute<T> {
    storageSet = (value: T): void => {
        HelperSrc.writeStorage<T>("router", value);

        HelperSrc.storageDispatchEvent("router");
    };

    storageGet = (): T | undefined => {
        const result = HelperSrc.readStorage<ModelCustomRoute.Idata>("router");

        if (result) {
            const historyState = window.history.state as Record<string, unknown> | undefined;
            const parameterList = historyState ? (historyState.parameterList as Record<string, unknown>) : undefined;

            result.user_profile.onClick = () => HelperSrc.routerHistoryPush(result.user_list.path, parameterList);
            HelperRoute.setCustomOnClick(result, parameterList);
        }

        return result as T;
    };

    storageRemove = (): void => {
        HelperSrc.removeStorage("router");
    };
}
